import { useQuery, useMutation, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { qualifyUrl } from "util/URLUtils";
import * as URLUtils from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { defaultOnError } from "util/conditional/onError";
import { DATA_LAKE_API_ROUTES } from "../Constants";
const refetchInterval = 3e3;
const getQueryKey = (streamId) => ["data-lake", "jobs", streamId];
const fetchDataLakeJob = (streamId) => {
  const url = streamId ? DATA_LAKE_API_ROUTES.DataLakeAPIController.job.stream_jobs(streamId).url : DATA_LAKE_API_ROUTES.DataLakeAPIController.job.progress().url;
  return fetch("GET", qualifyUrl(url));
};
const cancelDataLakeJob = (id) => fetch("DELETE", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.job.cancel(id).url));
const acknowledgeDataLakeJob = (id) => fetch("DELETE", URLUtils.qualifyUrl(ApiRoutes.SystemJobsApiController.acknowledgeJob(id).url));
const useDataLakeJobs = (streamId) => {
  const queryClient = useQueryClient();
  const {
    data,
    refetch: refetchDataLake,
    isLoading: isLoadingDataLake,
    isError
  } = useQuery({
    queryKey: getQueryKey(streamId),
    queryFn: () => defaultOnError(
      fetchDataLakeJob(streamId),
      i18n.t("notifications.fetch_jobs_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_jobs_failed_title", { ns: "enterprise_data_lake" })
    ),
    placeholderData: keepPreviousData,
    refetchInterval,
    notifyOnChangeProps: ["data", "error"]
  });
  const { mutateAsync: onCancelDataLakeJob } = useMutation({
    mutationFn: cancelDataLakeJob,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKey() });
    },
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.job_cancel_failed", { ns: "enterprise_data_lake", error: errorThrown }),
        i18n.t("notifications.job_cancel_failed_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  const { mutateAsync: onAcknowledgeDataLakeJob } = useMutation({
    mutationFn: acknowledgeDataLakeJob,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKey() });
    },
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.job_acknowledge_failed", { ns: "enterprise_data_lake", error: errorThrown }),
        i18n.t("notifications.job_acknowledge_failed_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  return {
    dataLakeData: {
      inProgressCount: data == null ? void 0 : data.in_progress,
      jobs: data == null ? void 0 : data.progress
    },
    isError,
    refetchDataLake,
    isLoadingDataLake,
    onCancelDataLakeJob,
    onAcknowledgeDataLakeJob
  };
};
export default useDataLakeJobs;
